module.exports = __webpack_public_path__ + "img/logo.42963797.png";